import React from 'react'

import Checkbox from 'presentation/shared/components/Checkbox'
import SelectPendencyStatus from '../SelectPendencyStatus'
import TextArea from 'presentation/shared/components/TextArea'
import Button from 'presentation/shared/components/Button'

import * as S from './styles'
import { DoctorRegistrationSteps } from 'common/enum/doctor-overall-registration-steps'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import SupportText from 'presentation/shared/components/SupportText'
import { DoctorRegisterStepStatus } from 'domain/entities/doctor-register'
import { MedicalTeam } from 'domain/entities/MedicalTeam'
import {
  disableObservation,
  generateNewRegistrationDetailsValidationSchema
} from 'presentation/hospital/layouts/DoctorRegister/NewRegistrationsDetails'
import { newRegistrationDetailsContext } from 'presentation/hospital/layouts/DoctorRegister/NewRegistrationsDetails/context'

type ActingSectorsProps = {
  actingSectors?: string[]
  initialValues: registerPendencyValues
  teams?: MedicalTeam[]
  updateStepStatus?: (step: any, initialValues: any) => Promise<void>
}

const ActingSectors = ({
  actingSectors,
  teams,
  initialValues,
  updateStepStatus
}: ActingSectorsProps) => {
  const { isStepsUpdateBlocked } = newRegistrationDetailsContext
  const setPendencyStatus = (field: string, event: any) => {
    setFieldValue(
      `${field}.status`,
      event.target.value === 'Pendente'
        ? DoctorRegisterStepStatus.PENDENT
        : DoctorRegisterStepStatus.APPROVED_DOCTOR_REGISTER
    )
  }

  const { handleChange, values, setFieldValue, handleSubmit, isValid } =
    useFormik({
      initialValues: initialValues,
      validateOnMount: true,
      validationSchema: generateNewRegistrationDetailsValidationSchema(
        DoctorRegistrationSteps.SECTORS_OF_ACTIVITY,
        DoctorRegistrationSteps.TEAMS
      ),
      onSubmit: async (values) => {
        try {
          await updateStepStatus?.(values, initialValues)
          toast.success('Dados enviados com sucesso.')
          window.scrollTo(0, 0)
        } catch (error) {
          toast.error('Erro ao salvar dados.')
          return
        }
      }
    })

  return (
    <S.Wrapper data-testid="card-acting-sectors">
      <S.PendencySelection>
        <SelectPendencyStatus
          handleChange={(e) =>
            setPendencyStatus(DoctorRegistrationSteps.SECTORS_OF_ACTIVITY, e)
          }
          initialValue={
            values[DoctorRegistrationSteps.SECTORS_OF_ACTIVITY].status
          }
          data-testid="select-pendency-status-acting-sectors"
          disabled={isStepsUpdateBlocked}
        />
      </S.PendencySelection>
      <S.Title>Setores de atuação</S.Title>
      <S.SectorsContainer>
        <section>
          {actingSectors &&
            actingSectors.map((sector, key) => (
              <Checkbox
                data-testid={`check-box-acting-sector-${key}`}
                key={key}
                label={sector}
                value={sector}
                checked
              />
            ))}
        </section>
      </S.SectorsContainer>
      <S.PendencyJustification>
        <TextArea
          name={`${DoctorRegistrationSteps.SECTORS_OF_ACTIVITY}.description`}
          label="No caso de pendência, favor descrever"
          value={
            values[DoctorRegistrationSteps.SECTORS_OF_ACTIVITY].description
          }
          onChange={handleChange}
          data-testid="input-pendency-acting-sector"
          disabled={
            disableObservation(DoctorRegistrationSteps.SECTORS_OF_ACTIVITY) ||
            values[DoctorRegistrationSteps.SECTORS_OF_ACTIVITY].status !==
              DoctorRegisterStepStatus.PENDENT ||
            isStepsUpdateBlocked
          }
          required
        />
      </S.PendencyJustification>
      <S.PendencySelection style={{ marginTop: '24px' }}>
        <SelectPendencyStatus
          handleChange={(e) =>
            setPendencyStatus(DoctorRegistrationSteps.TEAMS, e)
          }
          initialValue={values[DoctorRegistrationSteps.TEAMS].status}
          data-testid="select-pendency-status-acting-sectors"
          disabled={isStepsUpdateBlocked}
        />
      </S.PendencySelection>
      <S.Title>Equipes</S.Title>
      <S.TeamsContainer>
        <SupportText color="primary">
          Equipes selecionadas pelo profissional
        </SupportText>
        <ul>
          {teams &&
            teams.map((team, key) => <li key={key}>{team.description}</li>)}
        </ul>
      </S.TeamsContainer>
      <S.PendencyJustification>
        <TextArea
          name={`${DoctorRegistrationSteps.TEAMS}.description`}
          label="No caso de pendência, favor descrever"
          value={values[DoctorRegistrationSteps.TEAMS].description}
          onChange={handleChange}
          data-testid="input-pendency-acting-sector"
          disabled={
            disableObservation(DoctorRegistrationSteps.TEAMS) ||
            values[DoctorRegistrationSteps.TEAMS].status !==
              DoctorRegisterStepStatus.PENDENT ||
            isStepsUpdateBlocked
          }
        />
      </S.PendencyJustification>
      <S.ActionsButtons>
        <Button
          data-testid="btn-save-acting-sectors"
          onClick={() => handleSubmit()}
          variant={isValid && !isStepsUpdateBlocked ? 'outlined' : undefined}
          disabled={!isValid || isStepsUpdateBlocked}
        >
          Salvar
        </Button>
      </S.ActionsButtons>
    </S.Wrapper>
  )
}
type registerPendencyValues = {
  [DoctorRegistrationSteps.SECTORS_OF_ACTIVITY]: {
    description?: string
    status: DoctorRegisterStepStatus
  }
  [DoctorRegistrationSteps.TEAMS]: {
    description?: string
    status: DoctorRegisterStepStatus
  }
}
export default ActingSectors
